
var greek = {
    ////First Screen
   landing_welcome: 'Καλωσόρισες!'
   , hello_title: 'Γεια'
   , btn_login: "Σύνδεση"
   , btn_cancel: 'Άκυρο'
   , btn_send_opt: "Αποστολή κωδικού μίας χρήσης"
   , btn_register: "Εγγραφή"
   , btn_submit: 'Υποβολή'
   , btn_save: 'Φύλαξη'
   , btn_process: "Προχωρήστε"
   , btn_next: 'Επόμενο'
   , btn_done: 'Ολοκλήρωση'
   , btn_continue: 'Συνέχεια'
   , btn_edit: 'Επεξεργασία'
   , btn_apply: 'Apply'
   , btn_pay:"Pay"
   , btn_new_address: "+ Νέα Διεύθυνση"
   , landing_loyalty: "CRM.COM Release App"

   //Forgot password
   , forgot_password:'Ξέχασα τον κωδικό'
   , forgot_password_desc: 'Εισάγετε την διεύθυνση ηλεκτρονικού ταχυδρομείου σας παρακάτω. Θα το επαναφέρουμε και θα σας σταλούν οδηγίες για την επαναφορά του κωδικού πρόσβασής σας.'
   ///Register Screen
   , first_name: 'Όνομα'
   , last_name: 'Επίθετο'
   , email: 'Διεύθυνση ηλεκτρονικού ταχυδρομείου'
   , gender: 'Φύλο'
   , name_day: "Ονομαστική Εορτή"
   , language: 'Γλώσσα'
   , female: 'Γυναίκα'
   , male: 'Άντρας'
   , date_of_birth: "Ημερομηνία Γεννήσεως"
   , name_day: "Ονομαστική Εορτή"
   , password: "Κωδικός Πρόσβασης"
   , confirm_password: 'Επιβεβαίωση Κωδικού Πρόσβασης'
   , profile_detail: 'Προφίλ'
   , register_introduction: "Καταχωρίστε τα στοιχεία σας και πατήστε Εγγραφή για να συνεχίσετε."
   , phone_number: 'Αριθμός Κινητού'
   , do_you_have_account: "Δεν έχετε εγγραφεί ακόμα;"
   , enter_your_phone_number: "Εισάγετε αριθμό τηλεφώνου"
   , enter_your_firstname: "Εισάγετε όνομα"
   , enter_your_lastname: "Εισάγετε επίθετο"
   , email_input_placeholder: "Εισάγετε email"
   , confirm_password_placeholder: "Επιβεβαίωση Κωδικού Πρόσβασης"
   , already_account: "Έχετε ήδη λογαριασμό;"
   , exits_rewards_participant: 'Συμμετέχετε ήδη στο πρόγραμμα;'
   , yes: 'Ναι'
   , no: 'Όχι'
   , receive_marketing_information: 'Θέλω να λαμβάνω πληροφορίες μάρκετινγκ μέσω:'
   , referral_code: 'Κωδικός πρόσκλησης'
   , resend_email_verification:'Eπαναποστολή μηνύματος'
   , verify_email_desc:'Στάληκε μήνυμα στο '
   , verify_email_desc_2:' για επαλίθευση στοιχείων. Ελέγξτε τον σύνδεσμο που στάλθηκε στο email σας και ακολουθήστε τις οδηγίες για να επαληθεύσετε τον λογαριασμό σας.'
   //OTP Screen
   , resend_code: 'Αποστολή κωδικού ξανά'
   , verify_introduction_1: "Ένα SMS μιας χρήσης έχει σταλεί "
   , verify_introduction_2: ". Εισαγάγετε το για να επαληθεύσετε τον λογαριασμό σας."
   , term_and_conditions_upper: "Όρους και Προϋποθέσεις"
   , term_and_conditions_pre: " Συμφωνώ με τους "
   , authenticate: "Πιστοποίηση"
   , authenticate_and_sign_in: "Σύνδεση"
   , otp_title: 'Ένας κωδικός μιάς χρήσης έχει σταλεί στο τηλέφωνο '
   , otp_title2: '. Εισαγάγετε τον κωδικό πρόσβασης για έλεγχο ταυτότητας.'
   , an_sms: 'Ένα SMS '
   , an_email: 'Ενα μήνυμα ηλεκτρονικού ταχυδρομείου '
   , resend_verification_email: 'Resend verification email'
   , warning_message_agree:'You must agree to the Terms & Conditions and Privacy Policy in order register.'
   , otp_desc: 'An OTP is sent to your email. Please enter the password to authenticate'
   //Login Screen
   , dont_have_account: "Δεν έχετε λογαριασμό; "
   , user_name: 'Όνομα χρήστη'
   , password: 'Κωδικός Πρόσβασης'
   , enter_your_username: 'Εισάγετε όνομα χρήστη'
   , enter_your_password: 'Εισάγετε κωδικό πρόσβασης'
   , select_favourite_store_desc:"Επέλεξε το αγαπημένο σου κατάστημα"

   //Request permission
   , allow_location_title: 'Να επιτραπεί πρόσβαση στο '
   , allow_location_title_2: " στην τοποθεσία αυτής της συσκευής;"
   , allow_all_time: 'Να επιτραπεί πρόσβαση συνέχεια'
   , allow_only_use: 'Να επιτραπεί πρόσβαση μόνο όσο χρησιμοποιείτε η εφαρμογή'
   , deny: 'Να μην επιτραπεί πρόσβαση'

   //Bottom Tab
   , home_title: 'Αρχική'
   , offers_title: "Προσφορές"
   , merchants_title: "Συνεργάτες"
   , spend_title: "Επιστροφή χρημάτων"
   , profile_title: "Προφίλ"
   , order_title: 'Παραγγελίες'
   , map_title:'Χάρτης'
   , subcriptions_title: 'Subscriptions'
   , online_shop_title: "Online Καταστήματα"
   //Home
   , overview: "Περίληψη"
   , add_a_card: 'Πρόσθεση κάρτας'
   , add_a_card_suggest: 'Εισάγετε μια έγκυρη τραπεζική κάρτα για να πληρώσετε για παραγγελίες μέσω της εφαρμογής.'
   , add_a_card_suggest_rewards:'Εισάγετε μια έγκυρη τραπεζική κάρτα και οι αγορές σας θα ανταμοίβονται αυτόματα.'
   , wallet_balance: "Υπόλοιπο Πορτοφολιού"
   , my_wallet: 'Το πορτοφόλι σου'
   , spend_condition: 'Κριτήρια εξαργύρωσης'
   , any_where: "Ανοικτό Υπόλοιπο"
   , special_condition: "Εμπορικό Υπόλοιπο"
   , my_units: "Οι μονάδες μου"
   , you_have: "Έχετε "
   , units: " μονάδες."
   , target_unit: "Χρειάζεστε επιπλέον "
   , target_unit_2: " μονάδες μέχρι "
   , target_unit_3: " για να φτάσετε στο "
   , target_unit_3_b: " για να παραμείνετε στο "
   , target_unit_4:" επίπεδο."
   , order_online: "Παραγγείλετε online τώρα!"
   , delivery: "Παράδοση"
   , pickup: "Παραλαβή"
   , direct_sale: "Άμεση πώληση"
   , my_current_location: "Tρέχουσα Tοποθεσία"
   , current_location: "Tρέχουσα Tοποθεσία"
   , set_current_location: "Ορίστε τρέχουσα τοποθεσία"
   , pickup_location: 'Τοποθεσία παραλαβής'
   , reward_tier: "Επίπεδο ανταμοιβής σου"
   , recommended_offers: 'Προτεινόμενες προσφορές'
   , barcode: 'Barcode'
   , weekly_cashback: "Εβδομαδιαία επιστροφή χρημάτων"
   , explorer_more: 'Explore More!'
   //Offer screen
   , search_for: "Ψάξτε για..."
   , filter: "Φίλτρα"
   , industries: "Βιομηχανίες"
   , industry_sectors: "Κλάδοι βιομηχανίας"
   , location: "Τοποθεσία"
   , locations: "Τοποθεσίες"
   , tags: "Ετικέτες"
   , offer_detail_title: "Λεπτομέρειες προσφοράς"
   , view_more: 'Δείτε περισσότερα'
   , search_area: 'Google Search'
   , town_city: "Πόλη/Eπαρχία"
   //Profile
   , my_profile: "Προφίλ"
   , my_account: "Λογαριασμός"
   , notifications: "Ειδοποιήσεις"
   , logout: "Αποσύνδεση"
   , cards: "Κάρτες"
   , my_cards: "Κάρτες για ανταμοιβή"
   , my_cards_orders: "Κάρτες για παραγγελίες"
   , my_cards_rewards: "Κάρτες για ανταμοιβή"
   , participating_schemes: "Προγράμματα που συμμετάσχεις"
   , transactions: "Ιστορικό Συναλλαγών"
   , participate_in: 'Προγράμματα στα οποία συμμετέχεις'
   , join_more_schemes: 'Εγγραφείτε σε περισσότερα προγράμματα'
   , join_a_scheme: 'Εγγραφείτε σε ένα Πρόγραμμα'
   , refer_a_friend: 'Προσκάλεσε έναν φίλο'
   , referred_friends: 'Φίλους που έχετε προσκαλέσει'
   , refer_a_friend_title: "Συστήστε μας σε φίλους."
   , refer_a_friend_desc: 'Προσκαλέστε τους φίλους σας στην εφαρμογή '
   , refer_a_friend_desc2: ' και λάβετε το βραβείο. Μην ξεχάσετε να μοιραστείτε τον κωδικό σας μαζί τους όπως απαιτείται κατά την εγγραφή τους.'
   , refer_a_friend_intro: 'Αποστολή κωδικού μέσω ηλεκτρονικού ταχυδρομείου ή/και τηλεφώνου.'
   //, refer_a_friend_email: 'Προσθήκη ηλεκτρονικού ταχυδρομείου/τηλεφώνου (διαχωρισμένα με κόμμα)'
   , rewards_transactions: 'Συναλλαγές επιβράβευσης'
   , order_history: 'Ιστορικό Παραγγελιών'
   , wallet_journals: 'Συναλλαγές Πορτοφολιού'
   , wallets: "Πορτοφόλια"
   , payment_method: "Μέθοδοι Πληρωμής"
   , spending_preferences: "Προτιμήσεις Εξαργύρωσης"
   , address_book: "Διευθύνσεις"
   , select_from_the_list: "Επιλέξτε από τη λίστα"
   , change_password: "Αλλαγή κωδικού πρόσβασης"
   , new_password: 'Νέος κωδικός πρόσβασης'
   , confirm_new_password: 'Επιβεβαίωση νέου κωδικού πρόσβασης'
   , prefered_order: 'Αγαπημένη τοποθεσία για παραγγελίες'
   , prefered_rewards: 'Αγαπημένη τοποθεσία'
   , id_number: 'ID Number'
   , enter_id_number: 'Enter ID Number'
   , passport_number: 'Passport Number'
   , enter_passport_number: 'Enter Passport Number'
   , statutory_number : 'Statutory Number'
   , enter_statutory_number : 'Enter Statutory Number'
   // Image picker
   , open_settings: 'Ανοίξτε τις ρυθμίσεις'
   , take_a_photo: 'Βγάλε μία φωτογραφία'
   , from_gallery: 'Από το Gallery'
   // Address
   , new_address_title: 'Νέα διεύθυνση'
   , edit_address_title: 'Επεξεργασία Διεύθυνσης'
   , select_address: 'Επιλέξτε Διεύθυνση'
   , type: 'Τύπος'
   , address_line: 'Διεύθυνση Γραμμή '
   , address_line_suggest:'(Κτίριο, Όροφος, Άρ. Διαμ)'
   , city: 'Πόλη'
   , postal_code: 'Ταχυδρομικός Κώδικας'
   , state: "Πολιτεία/Επαρχία"
   , country: "Χώρα"
   , set_as_primary: "Ορισμός ως κύρια διεύθυνση"
   , address_name: "Ετικέτα"
   , please_select_address: 'Αναζητήστε μια διεύθυνση και επιλέξτε την ή κάντε κλικ στην τοποθεσία της διεύθυνσης στον χάρτη'
   // Home
   , total_cashback: 'Συνολικά κέρδη επιστροφής χρημάτων'
   , recent_cashback: 'Πρόσφατα κέρδη επιστροφής χρημάτων'
   , allotment_title: "Υπολοίπου πορτοφολιού"
   , allotment_desc: "Το Ανοικτό Υπόλοιπο αφορά χρήματα στο πορτοφόλι σας από top up και δεν υπόκειται σε κριτήρια εξαργύρωσης. Το Εμπορικό Υπόλοιπο δημιουργείτε από την επιστροφή χρημάτων από βραβεία και προσφορές και μπορεί να δαπανηθεί κατά την αγορά. Τα κριτήρια εξαργύρωσης του εμπορικού υπολοίπου είναι τα εξής:"
   , allotment_condition: "Το ποσό μπορεί να εξαργυρωθεί "
   , on: ""
   , and: "και "
   , at: "στις "
   , between: "μεταξύ "
   , any_day: "οποιαδήποτε μέρα "
   , any_time: "οποιαδήποτε ώρα "
   , all_locations: "όλες τις τοποθεσίες "
   , the_following_venues: 'ακόλουθες τοποθεσίες'
   // Transaction
   , purchase_amount: "Ποσό αγοράς"
   , award_amount: "Ποσό επιβράβευσης"
   , spend_amount: "Ποσό εξαργύρωσης"
   , discount_amount: "Ποσό Έκπτωσης"
   , rewards_breakdown: 'Ανάλυση Ανταμοιβών'
   , total_award_amount: 'Συνολικό ποσό ανταμοιβής:'
   , spend_on_request_amount: 'Ποσό Αίτημας Δαπάνης:'
   , instant_discount_amount: 'Ποσό Άμεσης Έκπτωσης:'
   , automatic_spend_amount: 'Ποσό Αυτόματης Δαπάνης:'
   , applied_fees: 'Εφαρμοσμένα Τέλη'
   , total_fee_amount: 'Συνολικά Τέλη:'
   , fee_on_awards: 'Τέλη από Επιβράβευση:'
   , fee_on_spend: 'Τέλη από Δαπάνη:'
   , ad_hoc_return: 'Επιστροφή'
   , requested_return_amount: 'Ζητούμενο Ποσό Επιστροφής:'
   , actual_return_amount: 'Πραγματικό Ποσό Επιστροφής:'
   , requested_on: 'Ζητήθηκε στις:'

   
    //Wallet Journals
    , reward_event: 'Προσφορά'
    , reward_event_amout: 'Ποσό'
    , reward_event_spend_method: 'Μέθοδος εξαργύρωσης'
    , reward_event_state: 'Κατάσταση'
    , reward_event_date: 'Ημερομηνία'
    , reward_event_offer_name: 'Όνομα Προσφοράς'
    , spend_method_on_request: 'κατόπιν αίτησης'
    , spend_method_instant : 'Έκπτωση'
    , spend_method_automatic : 'Αυτόματη εξαργύρωση'

    , financial_event: 'Οικονομική Πράξη'
    , financial_event_number: 'Αριθμός πράξης'
    , financial_event_reference_number: 'Αριθμός αναφοράς'
    , financial_event_life_cycle_state: 'Κατάσταση'
    , financial_event_date: 'Ημερομηνία'
    , financial_event_amount: 'Ποσό'
    , financial_event_top_up: 'TOP UP'//'ΠΡΟΣΘΗΚΗ'
    , financial_event_transfer: 'TRANSFER'//'ΜΕΤΑΦΟΡΑ'
    , financial_event_order: 'ORDER'//'ΠΑΡΑΓΓΕΛΙΑ'
    , pass_redeemed: 'PASS REDEEMED'//'ΔΩΡΟΚΑΡΤΑ'

    , wallet_fee: 'Τέλη Πορτοφολιού'
    , wallet_fee_name: 'Τέλος'
    , wallet_fee_type: 'WALLET FEES'

    , journal_order: 'Παραγγελία'
    , journal_order_number: 'Αριθμός'
    , journal_order_total_cost: 'Συνολικό Κόστος'
    , journal_order_submitted_on: 'Υποβλήθηκε στις'
    , journal_order_fulfilled_by: 'Εκπληρώθηκε από'

    //Subcriptions
    , auto_renew: 'Auto renewing on'
    , sub_contract_period: 'Contract Period'
    , sub_trial_period: 'Trial period'
    , subscriptions_title: 'Subcriptions'
    , billing_day: 'Billing Day'
    , next_billing_day: 'Next Billing Date'
    , month_title: 'Months'
    , monthly: 'Monthly'
    , state_effective: 'Effective'
    , in_contract: 'In Contract'
    , in_trial: 'In Trial'
    , added_on: 'Added on'
    , active_since: 'Active since'
    , removed_on: 'Removed on'
    , firts_activated_on: 'Firts activated on'
    , recurring_charge: 'Recurring charge'
    , recurring_payment: 'Change payment card'
    , latest_billed_period: 'Latest billed period'
    , devices: 'Devices'
    , on_customer_premises_since: 'On customer premises since: '
    , provisions: 'Provisions:'
    , expense_service: 'Expense Service'
    // Order Service
    , per: "per"
    , TAX_INCLUSIVE: "Tax Inclusive"
    , TAX_EXCLUSIVE: "Tax Exclusive"
    , tax_model_desc:"Termed period covers "
    , tax_model_desc_1: " billing cycle"
    , auto_renewed:"Auto renewed at end of of termed period"
    , no_contract_period:"No Contract Period"
    , no_trial_period:"No Trial Period"
    , trial_period:"trial period"
    , contract_period:"contract period"
    

   //MoreInfo
   , about_title: 'Σχετικά με την εφαρμογή'
   , privacy_title: 'Πολιτική απορρήτου'
   , contact_us_title: 'Επικοινωνήστε μαζί μας'
   , faq_title: 'Συχνές ερωτήσεις'
   , term_condition_title: 'Όροι και Προϋποθέσεις'

   //Setting
   , setting_title: "Ρυθμίσεις"
   , allow_notifications: "Να επιτρέπονται ειδοποιήσεις"
   , marketing_information: "Πληροφορίες μάρκετινγκ"
   , marketing_information_desc: "Θα ήθελα να λαμβάνω διαφημιστικές πληροφορίες σχετικά με προσφορές και άλλο υλικό που σχετίζεται με το "
   , marketing_information_desc_2: "εφαρμογή μέσω:"
   , marketing_information_request: "Θα θέλατε να λαμβάνετε διαφημιστικές πληροφορίες σχετικά με προσφορές και άλλο υλικό που σχετίζεται με την "
   , marketing_information_request2: " εφαρμογή;"
   , marketing_information_sure: "Ναι"
   , marketing_information_no: "Όχι"
   , setting_email: 'Email'
   , setting_sms: 'SMS'
   , setting_allow_geo_tracking: 'Να επιτρέπεται η γεωγραφική παρακολούθηση'
   , setting_language: 'Γλώσσα'

   //Orders
   , order_promotion: 'Προσφορές'
   , order_method: 'Παραγγείλτε τώρα:'
   , order_my_orders: 'Πρόσφατες παραγγελίες'
   , order_select_address: 'Επιλέξτε Διεύθυνση'
   , order_select_store: 'Επιλέξτε Κατάστημα'
   , my_address: 'Διευθύνσεις'
   , change_store: "Αλλαγή καταστήματος"
   , change_merchant: "Αλλαγή καταστήματος"
   , add_to_cart: 'Προσθήκη στο καλάθι'
   , add_to_cart_desc: 'Add a valid bank card and use it to pay for your delivery or pick up orders. '
   , update_cart: 'Ενημέρωση'
   , remmove_cart: 'Κατάργηση αντικειμένου'
   , cart: "Καλάθι"
   , award_point: "Βαθμοί βραβείων"
   , you_will_spend: "θα εξαργυρώσετε "
   , you_will_have: "θα έχετε "
   , you_will_earn: "θα κερδίσεις "
   , point: "μονάδες"
   , total: "Σύνολο"
   , add_notes: "Προσθέστε σημειώσεις"
   , add_your_note: "Επιπρόσθετες Σημειώσεις"
   , note_place_holder: "Πληκτρολογήστε εδώ"
   , notes: 'Notes:'
   , place_order: "Καταχωρήστε την παραγγελία"
   , about_order: "Προεπισκόπηση παραγγελίας:"
   , delivery_to: "Παράδοση"
   , expected_delivery_time: "Αναμενόμενος χρόνος παράδοσης"
   , expected_preparation_time: "Αναμενόμενος χρόνος προετοιμασίας"
   , expected_pickup_time: "Αναμενόμενος χρόνος παραλαβής"
   , pick_up_time:"Ώρα παραλαβής"
   , nearby_pickup_location: "Κατάστημα παραλαβής"
   , including_preparation_time: "συμπεριλαμβανομένου του χρόνου προετοιμασίας"
   , order_to_be_fulfilled_by: "Παραγγελία θα εκπληρωθεί από "
   , select_payment_method: "Επιλέξτε τον τρόπο πληρωμής σας"
   , select_your_card: "Επιλέξτε την κάρτα σας"
   , paypal: "PayPal"
   , cards: "Κάρτα"
   , cash: "Μετρητά"
   , wallet: "Πορτοφόλη"
   , your_wallet: "Έχετε "
   , your_wallet_2: " στο πορτοφόλη σας"
   , placing_your_order: 'Υποβολή της παραγγελίας σας'
   , take_away_from:'Παραλαβή από'
   , delivery_from:'Παράδοση στη'
   , ready_in:'Έτοιμο σε'
   , order_number:'Αριθμός παραγγελίας'
   , order_placed:'Ολοκλήρωση παραγγελίας'
   , select_store: 'Επιλέξτε κατάστημα'
   , change:'Αλλαγή'
   , warning:'Προειδοποίηση'
   , warning_leave_cart:'Πρόκειται να φύγετε από το καλάθι. Θέλετε να συνεχίσετε;'
   , use_funds_from_wallet:"Χρησιμοποιήστε το πορτοφόλι σας"
   , to_be_paid_with_funds:"Θα πληρωθεί από το πορτοφόλι"
   , amount_due:"Οφειλόμενο ποσό"
   , consider_an_upgrade: "Σκεφτείτε μια αναβάθμιση"
   , recommendations:"Συστάσεις"
   , your_order:"Παραγγελία σας"
   , sub_total:'Μερικό Σύνολο'
   , Tap_here_to_continue: 'Tap here to continue'
   , Cash_on_delivery: 'Cash on delivery'
   , Cash_on_pikup: 'Cash on pickup'
   , Please_check_cash: 'Please check that you have the exact amount of cash'
   , Please_check_card: 'Please check that you have the exact amount of card'
   , promotion_discount: "Ποσό 'Εκπτωσης"
   , reorder: 'Reorder'
   , manage_card: 'Άλλη κάρτα'
   , order_catalogues:'Order Catalogues'
   //Referral code
   , referral_code_title: 'Κωδικός πρόσκλησης'
   , referral_code_placeholder: 'Εισάγετε τον κωδικό πρόσκλησής σας'
   , referral_code_info: 'Λάβατε πρόσκληση από έναν φίλο;'
   , referred_code_require: 'Εισάγετε τον κωδικό πρόσκλησής σας παρακάτω.'
   , skip: 'Παράλειψη'
   , referral_code2: 'Κωδικός πρόσκλησης'
   , refer_emails:'Emails'
   , refer_phones:'Αριθμούς Τηλεφώνου'
   , refer_a_friend_email: 'Καθορίστε emails (μέγιστο αρ. 10)'
   , refer_a_friend_phone: 'Καθορίστε αριθμούς τηλεφώνου (μέγιστο αρ. 10)'
   , order_items:'Order Items'
   //Identify
   , identify_title: 'Βοηθήστε μας να σας αναγνωρίσουμε'
   , select_identify: 'Επιλέξτε μέθοδο αναγνώρισης'
   , loyalty_card: 'Αριθμός κάρτας επιβράβευσης'
   , receive_one_time_password: 'Λάβετε ένα SMS μιας χρήσης για επαλήθευση μέσω εγγεγραμμένου:'
   , card_input_placeholder: 'Εισαγάγετε τον αριθμό της κάρτας σας'
   , auth_credentinal: 'Εισαγάγετε ένα έγκυρο '
   , auth_credentinal_2: ' για χρήση ως διαπιστευτήρια σύνδεσης στο '
   , auth_credentinal_email: 'διεύθυνση ηλεκτρονικού ταχυδρομείου και κωδικό πρόσβασης'
   , auth_credentinal_phone: 'αριθμός τηλεφώνου'   
   //Service owner
   , service_owner_home:'Αρχική'
   , participating_shop:'Αναζήτηση'
   , request_to_join:'Αίτημα συμμετοχής σε ένα πρόγραμμα.'
   , join_place_confirm: "Θα θέλατε να συμμετάσχετε στο "
   , loyalty_scheme: " πρόγραμμα"
   , manually_option: 'Ή πληκρολογείστε τα στοιχεία της κάρτας'
   , scan:"Σάρωση"
   , card_number: 'Αριθμός Κάρτας'
   , enter_card_number: 'Εισάγετε τον αριθμό της κάρτας'
   , spend_setting: 'Ρυθμίσεις Εξαργυρώσεων'
   , spend_setting_intro: 'Καθορίστε τον τρόπο με τον οποίο οι επιβραβεύσεις θα εξαργυρόνονται αυτόματα'
   , start_spending: 'Θέλω να ξοδέψω όταν έχω περισσότερο από'
   , allowed_amount: 'Ελάχιστο ποσό που θέλω να ξοδέψω'
   , enter_amount:'Εισάγετε Ποσό'
   , request_to_sign_off:'Αίτημα για έξοδο από το πρόγραμμα.'
   , sign_off_merchant_message: "Πρόκειται να καταργήσετε την εγγραφή σας από το πρόγραμμα "
   , sign_off_merchant_message_2: ". Εάν προχωρήσετε, θα χάσετε τυχόν ανταμοιβές έχετε αποκτήσει μέχρι σήμερα από αυτό το πρόγραμμα."
   , sign_off_success_part1: "Η κατάργηση της εγγραφής σας από το πρόγραμμα "
   , sign_off_success_part2: " ήταν επιτυχής"
   , search_for_shop:'Αναζητήστε ένα πρόγραμμα'
   , search_for_shop_suggest_text:'Αναζητήστε ένα πρόγραμμα. Πληκτρολογήστε τουλάχιστον 3 χαρακτήρες για αναζήτηση.'
   //

   //Spending preferfence
   , automatic_spend:"Προτιμήσεις αυτόματης Εξαργήρωσης"
   , one_time_password_spend_request:"One Time Password Spend Request"
   , automatic_spend_info:"Ενεργοποιήστε την αυτόματη εξαργύρωση για να επιλέξετε προτιμήσεις αυτόματης εξαργύρωσης"
   , one_time_password_spend_request_info:"No OTP Spend Request has been found"
   , enable_automatic_spend:"Enable automatic spends?"
   , request_otp_spend_title:"Request an One Time Password for spending on your next purchase"
   , request_otp_spend_amount:"Requested Spend Amount"
   , request_otp_no_spend_amount:"No spend amount restriction is specified"
   , request_otp_spend_suggest:"(leave blank to spend as much as possible)"
   , request_otp:"Request OTP"
   , otp_expires:"OTP expires"
   , and_purchase_at:'and purchase at'
   , select_merchant_to_spend:"Select on which Merchants you wish to spend"
   , spend_setting_merchant_intro: 'Specify on which merchant awards will be automatically spent (only once)'


   //Topup Wallet
   , topup_wallet: 'Επαναφόρτηση Πορτοφολιού'
   , current_balance: 'Υπόλοιπο Λογαριασμού'
   , recommended: 'Συστημένα'
   , debit_from: 'Χρέωση από'
   , automatically_topup: 'Automatically Top-Up'
   , auto_topup_title: 'Automatically top-up your wallet' 
   , auto_topup_desc_1: 'When the balance fails below'
   , auto_topup_desc_2: 'Add the following amount'
   , reset: 'Reset'
   
   //Service Requests
   , service_requests: 'Service Requests'
   , new_service_request: 'New Service Request'
   , title: 'Title'
   , queue: 'Queue'
   , description: 'Description'
   , add_files: 'Add Files'
   , create: 'Create'
   , classification: 'Classification'
   , closure_reason: 'Closure Reason'
   , response: 'Response'
   , please_chosse_classification: 'Please chosse classification'
   , create_service_request_success: 'Create service request success'
   , create_service_request_failed: 'Create service request failed'
   
    //Redeem Pass
    , redeem_pass: 'Εξαργύρωση Δωροκάρτας'
    , redeem: 'Εξαργύρωση'
    , redeem_desc: 'Εισάγετε τον αριθμό δωροκάρτας παρακάτω για να την εξαργυρώσετε'
    , pass_code: 'Αριθμός Δωροκάρτας'
    , pass_pin: 'PIN (αν υπάρχει)'


    //Online shop
    , address_title: "Διεύθυνση: "
    , location_name: "Ονομα τοποθεσίας: "
    , location_not_found: "Λεπτομέρειες τοποθεσίας δεν βρέθηκαν!"
    , title_notify_not_found: "Κοινοποιώ"
    , online_shop_detail_title: "Λεπτομέρεια τοποθεσίας"
    
    //our_partners
    , our_partners: 'Our Partners'

    //Confirm Message 
    , message_bank_card: 'Καταχωρήστε μία ή περισσότερες τραπεζικές κάρτες για να ενεργοποιηθεί η επιβράβευση των αγορών σας.'
    , add_a_card_now: 'Προσθήκη κάρτας τώρα'

    , mobile_pass_card: 'Mobile Pass Card'
    , mobile_pass_card_desc: 'Select one of the options to download the mobile pass card to your phone'
    , add_to_apple_wallet: 'Add to Apple Wallet'
    , add_to_wallet_passes: 'Add to Wallet Passes'
    , save_to_phone: 'Save to phone'
    , file_pkpass_not_found: 'PKPass File not found'

    //invoice page
    , invoice_title: 'Invoices'
    , account_balance: 'Account Balance'
    , overdue_amount: 'Overdue Amount'
    , account_finance: 'Account Finance'
    , invoices: 'Invoices'
    , btn_service_changes: 'Service Changes'
    , upgrade_service: 'Upgrade'
    , period_title: 'Specify period'
    , date_title: 'Transaction Date'
    , due_date: 'Due Date'
    , invoice_tax_amount: 'Tax'
    , invoice_net_amount: 'Net'
    , invoice_total_amount: 'Total'
    , unpaid_amount: 'Unpaid Amount'
    , paid_amount: 'Paid Amount'
    , account_title: 'Account'
    , currency_code: 'Currency'
    , invoice: 'Invoice'

    //register existing
    , register_existing_title: 'Registration'
    , contact_code: 'Contact Code'
    , enter_contact_code_placeholder: 'Enter Contact Code'
    , services_title: 'Services'    
    , remaining: 'Remaining'
    , remaining_allowance: 'Remaining Allowance'
    , periods_allowance: 'Periods Usage'
    , days: 'days'
    , can_not_find_customer: 'Email address not found'
    , can_not_find_email_customer: 'Can not find email of customer'
    // , upgrade_service_success: 'Upgrade service successfully'
    , upgrade_service_faild: 'Upgrade service failed'
    , upgrade_service_faild_credit_limit: 'Service upgrade failed. Your credit limit has been exceeded. Please contact our Service customer for further assistance'
    , products_tier: 'Service Upgrade'

    , from_date: 'From Date'
    , to_date: 'To Date'
    , invoice_number: 'Number'
    , invoice_posted_date: 'Posted Date'
    , invoice_issued_date: 'Issued Date'
    , invoice_due_date: 'Due Date'
    , invoice_overdue_amount: 'Overdue amount'
    , topup_title: 'Top-up'
    , account_management: 'Account Management'
    , my_account_number: 'Account Number'
    , credit_note: 'Credit Note'
    , payment: 'Payment'
    , refund: 'Refund'
    , payout: 'Payout'
    , transfer: 'Transfer'
    , manual_journal: 'Manual Journal'
    , transaction_type: 'Transaction Type'
    , invoice_amount: 'Amount'
    , print_out: 'Print Out'
    , no_available_upgrade_service: 'No available upgrade service'
    
    , update_subscription_success: 'Update payment card success'
    , update_subscription_faild: 'Update payment card failed'
    , card_is_already_selected: 'The card is already selected'

    , billing_period: 'Billing period'
    , confirm_upgrade: 'Do you want to upgrade to '


    //rules password
    , inform_password: 'The password:'
    , inform_password_1: '1) must be at least 8 characters in length.'
    , inform_password_2: '2) can contain alphanumeric characters'
    , inform_password_3: '3) can contain special characters'
    , inform_password_4: '4) cannot contain a sequence of characters or numbers (e.g. "abcdfg" or "123456")'
    , inform_password_5: '5) cannot be set to a previously used password'

    //management service
    , confirm_change_service: 'Do you want to change service to '
    , no_available_change_service: 'No available change service'
    , change_service: 'Change Service'
    , upgrade_service_success: 'Service upgraded successfully.'
    , upgrade_service_failed: 'Upgrade service failed.'
    , downgrade_service_success: 'Service downgraded succesfully.'
    , downgrade_service_failed: 'Downgrade service failed.'
    , cancel_service_success: 'Cancel service successfully.'
    , cancel_service_success_with_date: 'Cancellation of Service will be performed on '
    , cancel_service_failed: 'Cancel service failed.'
    , change_service_failed_credit_limit: 'Service upgrade failed. Your credit limit has been exceeded. Please contact our Service customer for further assistance'
    , change_service_failed: 'Change service failed.'
    , change_service_success: 'Change service successfully.'
    , confirm_cancel_service: 'Do you want to cancel service?'
    , confirm_pause_service: 'Do you want to pause service?'
    , pause_service_success: 'Pause service successfully.'
    , pause_service_failed: 'Pause service failed.'
    , btn_pause: 'Pause'
    , btn_resume: 'Resume'
    , btn_active: 'Activate'
    , confirm_resume_service: 'Do you want to resume service?'
    , resume_service_success: 'Resume service successfully.'
    , resume_service_failed: 'Resume service failed.'
    , confirm_active_service: 'Do you want to activate service?'
    , active_service_success: 'Service activated successfully.'
    , active_service_failed: 'Active service failed.'
    , down_service_success: 'Downgrade service successfully.'
    , btn_actions: 'Actions'

    , resume_service_success_with_date: 'Resume of Service will be performed on '
    , pause_service_success_with_date: 'Pause of Service will be performed on '
    , upgrade_service_success_with_date: 'Upgrade of Service will be performed on '
    , down_service_success_with_date: 'Downgrade of Service will be performed on '
    , active_service_success_with_date: 'Activate of Service will be performed on '
    
    , confirm_cancel_service_success_with_date: 'Do you want cancel service to be performed on '
    , confirm_resume_service_success_with_date: 'Do you want resume service to be performed on '
    , confirm_pause_service_success_with_date: 'Do you want pause service to be performed on '
    , confirm_upgrade_service_success_with_date: 'Do you want upgrade service to be performed on '
    , confirm_down_service_success_with_date: 'Do you want downgrade of service to be performed on '
    , confirm_active_service_success_with_date: 'Do you want activate service to be performed on '
    
    , amount_less_equal_than: 'Amount must be less or equal than '
    , amount_greater_than: 'Amount must be greater than 0!'
    , message_delete_card: 'Are you sure you want to delete this card?'
    
   , english: "Αγγλικά"
   , greek: 'Ελληνικά'

   ////
   , DAYS: {
       MONDAY: 'Δευτέρα',
       TUESDAY: 'Τρίτη',
       WEDNESDAY: 'Τετάρτη',
       THURSDAY: 'Πέμπτη',
       FRIDAY: 'Παρασκευή',
       SATURDAY: 'Σάββατο',
       SUNDAY: 'Κυριακή'
   }
   , SHORTDAYS: {
       MONDAY: 'Δευ',
       TUESDAY: 'Τρί',
       WEDNESDAY: 'Τετ',
       THURSDAY: 'Πέμ',
       FRIDAY: 'Παρ',
       SATURDAY: 'Σάβ',
       SUNDAY: 'Κυρ'
   }
   , SHORTMONTH: {
       JAN: 'Ιαν'
       , FEB: 'Φεβ'
       , MAR: 'Μάρ'
       , APR: 'Απρ'
       , MAY: 'Μάη'
       , JUN: 'Ιουν'
       , JUL: 'Ιουλ'
       , AUG: 'Αυγ'
       , SEP: 'Σεπ'
       , OCT: 'Οκτ'
       , NOV: 'Νοε'
       , DEC: 'Δεκ'
   }
   , MONTH: {
       JAN: 'Ιανουάριος'
       , FEB: 'Φεβρουάριος'
       , MAR: 'Μάρτιος'
       , APR: 'Απρίλιος'
       , MAY: 'Μαης'
       , JUN: 'Ιούνης'
       , JUL: 'Ιούλης'
       , AUG: 'Αύγουστος'
       , SEP: 'Σεπτέμβριος'
       , OCT: 'Οκτώβριος'
       , NOV: 'Νοέμβριος'
       , DEC: 'Δεκέμβριος'
   }
   , please_note:'Παρακαλώ σημειώστε'
   //Return message
   , ERROR: "Λάθος"
   , SUCCESS: "Επιτυχία"
   , EXCEPTION: "Εξαίρεση"
   , EXCEPTION_PROCESS: 'Το σύστημα αντιμετώπισε πρόβλημα κατά την επεξεργασία του αιτήματός σας'
   , REGISTRATION_FAIL_CONTACT_EXISTS: 'This email has been registered in the portal. Please sign in.'
   , REGISTRATION_FAIL_CONTACT_EXISTS_EMAIL: 'This email has been registered in the portal. Please sign in.'
   , INVALID_PHONE_LOGIN: 'Η σύνδεση απέτυχε. Ο αριθμός τηλεφώνου δεν είναι έγκυρος.'
   , INVALID_OTP: 'Μη έγκυρος κωδικός.'
   , INVALID_EMAIL_LOGIN: 'Η σύνδεση απέτυχε. Το όνομα χρήστη ή ο κωδικός πρόσβασης δεν είναι έγκυρα.'
   , PROFILE_UPDATE_SUSCESS: 'Το προφίλ ενημερώθηκε με επιτυχία.'
   , UPDATE_FAIL: 'Παρουσιάστηκε πρόβλημα με την ενημέρωση του προφίλ σας. Παρακαλώ προσπαθήστε ξανά αργότερα.'
   , PHONE_NUMBER_ALREADY_EXIST:'Ο καθορισμένος αριθμός τηλεφώνου είναι ήδη καταχωρημένος στο σύστημα. Ελέγξτε τον αριθμό σας και δοκιμάστε ξανά. Εάν αυτός ο αριθμός ανήκει σε εσάς επικοινωνήστε μαζί μας.'
   , CHANGE_PASSWORD_SUCCESS: 'Ο κωδικός πρόσβασης ενημερώθηκε με επιτυχία'
   , CHANGE_PASSWORD_FAIL: 'Παρουσιάστηκε πρόβλημα κατά την ενημέρωση του κωδικού πρόσβασής σας. Παρακαλώ προσπαθήστε ξανά αργότερα.'
   , GET_CONFIG_FAIL: "Παρουσιάστηκε πρόβλημα κατά την επεξεργασία για να λάβουμε τη διαμόρφωση. Παρακαλώ προσπαθήστε ξανά αργότερα."
   , REGISTER_EMAIL_SUCCESS: "You are almost there. We have sent you an email for verification. Please check and complete your registration"
   , REGISTER_EMAIL_SMS: "Your credential is created successfully. You can now sign in with your email."
   , OTP_RESEND_SUCCESS: "Ένα μήνυμα μιας χρήσης έχει σταλεί στον αριθμό του κινητού σας τηλεφώνου"
   , OTP_RESEND_EMAIL_SUCCESS: "Ένα μήνυμα OTP έχει σταλεί στο email σας"
   , access_photos_denied: 'Η πρόσβαση στις φωτογραφίες απαγορεύτηκε. Ενεργοποιήστε το στην εφαρμογή Ρυθμίσεις για να συνεχίσετε.'
   , access_camera_denied: 'Απαγορεύεται η πρόσβαση στην κάμερα. Ενεργοποιήστε το στην εφαρμογή Ρυθμίσεις για να συνεχίσετε.'
   , access_location_denied: 'Η πρόσβαση στην τοποθεσία απαγορεύτηκε. Ενεργοποιήστε το στην εφαρμογή Ρυθμίσεις για να συνεχίσετε.'
   , REWARDS_SCHEME_SIGN_UP_SUCCESS: 'Έχετε εγγραφεί με επιτυχία στο '
   , REWARDS_SCHEME_SIGN_UP_FAIL: 'Αποτυχία συμμετοχής στο πρόγραμμα '
   , REWARDS_SCHEME_SIGN_OUT_SUCCESS: 'Έχετε αποσυνδεθεί με επιτυχία'
   , REWARDS_SCHEME_SIGN_OUT_FAIL: 'Αποτυχία αποσύνδεσης '
   , ADD_ADDRESS_SUCCESS: 'Η διεύθυνση προστέθηκε με επιτυχία'
   , UPDATE_ADDRESS_SUCCESS: 'Η διεύθυνση ενημερώθηκε με επιτυχία'
   , REMOVE_ADDRESS_SUCCESS: 'Η διεύθυνση καταργήθηκε με επιτυχία'
   , FAILED_TO_UPDATE_ADDRESS: 'Η ενημέρωση νέας διεύθυνσης δεν ήταν επιτυχής.'
   , FAILED_TO_ADD_ADDRESS: 'Η αποθήκευση νέας διεύθυνσης δεν ήταν επιτυχής.'
   , ADD_ADDRESS_ALREADY_TYPE: 'Η αποθήκευση νέας διεύθυνσης δεν ήταν επιτυχής. Ο τύπος διεύθυνσής σας υπάρχει ήδη.'
   , FAILED_TO_REMOVE_ADDRESS: 'Η κατάργηση διεύθυνσης δεν ήταν επιτυχής'
   , CREATE_REERRAL_SUCCESS: 'Ο κωδικός παραπομπής καταχωρήθηκε με επιτυχία.'
   , CREATE_REERRAL_FAIL: 'Ελέγξτε τον κωδικό παραπομπής και δοκιμάστε ξανά.'
   , ORDER_SELECT_ADDRESS: 'Επιλέξτε μια διεύθυνση παράδοσης'
   , ORDER_SELECT_STORE: 'Επιλέξτε τοποθεσία'
   , DELIVERY_VALIDATION_LOCATION: 'Δυστυχώς, αυτή τη στιγμή η παράδοση δεν είναι διαθέσιμη στην περιοχή σας.'
   , PICK_UP_VALIDATION_LOCATION: 'Δυστυχώς, η παραλαβή δεν είναι δυνατή για τη συγκεκριμένη κατάστημα΄.'
   , DELIVERY_VALIDATION_TIME: 'Δυστυχώς, η παράδοση δεν είναι διαθέσιμη αυτή τη στιγμή.'
   , PICK_UP_VALIDATION_TIME: 'Δυστυχώς, η παραλαβή δεν είναι διαθέσιμη αυτή τη στιγμή.'
   , FULFILL_ORDER_EMPTY_EXCEPTION:'Δεν υπάρχουν κατάστηματα εντός εμβέλειας που να μπορούν να εκπληρώσουν την παραγγελία σας αυτήν τη στιγμή.'
   , ORDER_VALID_CARD: 'Πρέπει να προσθέσετε μια έγκυρη τραπεζική κάρτα για παραγγελείες παραλαβής.'
   , FAILED_TO_REMOVE_CARD: 'Η κατάργηση της κάρτας δεν ήταν επιτυχής'
   , REMOVE_CARD_SUCCESS: 'Η κάρτα αφαιρέθηκε με επιτυχία'
   , FORGOT_PASSWORD_SUCCESS:'Στείλαμε ένα ηλεκτρονικό ταχυδρομείο με οδηγίες για την επαναφορά του κωδικού πρόσβασής σας Παρακαλούμε ελέγξτε την ηλεκτρονική διεύθυνση σας.'
   , FORGOT_PASSWORD_FAIL:'Δεν μπορούμε να επαναφέρουμε τον κωδικό πρόσβασής σας αυτήν τη στιγμή. Παρακαλώ προσπαθήστε ξανά αργότερα.'
   , FORGOT_EMAIL_NOT_FOUND_EXCEPTION : 'Δυστυχώς, δεν αναγνωρίζουμε αυτήν τη διεύθυνση ηλεκτρονικού ταχυδρομείου.'
   , CAN_NOT_FULFILL_ORDER_EXCEPTION:'Το επιλεγμένο κατάστημα δεν μπορεί να εκπληρώσει την παραγγελία σας αυτήν τη στιγμή.'
   , PHONE_NUMBER_NOT_FOUND:'Πρέπει να προσθέσετε τον αριθμό τηλεφώνου σας για να συνεχίσετε.'
   , MINIMUM_ORDER_AMOUNT_NOT_REACHED:"Το ελάχιστο ποσό παραγγελίας δεν έχει επιτεύχθεί."
   , invalid_card: 'Παρακαλώ εισάγετε έγκυρο αριθμό κάρτας.'
   , CARD_ALREADY_EXIST: 'Ο αριθμός κάρτας υπάρχει ήδη'
   , FAILED_TO_ADD_CARD: 'Παρουσιάστηκε πρόβλημα κατά την προσθήκη κάρτας. Παρακαλώ δοκιμάστε ξανά αργότερα.'
   , ADD_NEW_CARD_SUCCESS:'Η προσθήκη κάρτας έγινε με επιτυχία'
   , UPDATE_SPEND_PREFERENCES_SUCCESS:'Η ενημέρωση έγινε με επιτυχία'
   , SIGN_UP_ORGANISATION_ALREADY:'Συμμετέχετε ήδη στο '
   , ADD_FINGERPRINT_FAIL:'Η εγγραφή της κάρτας απέτυχε. Δοκιμάστε ξανά'
   , SIGN_UP_OFF_ORGANISATION_IS_NOT_ALLOWED: 'Δεν επιτρέπεται η εγγραφή σε / απενεργοποίηση από άλλους οργανισμούς χρησιμοποιώντας το τρέχον διακριτικό πρόσβασης'
   , CONTACTUNIQUELYIDENTIFYEXCEPTION: "The email is not found. Please register with our call agent for further support."
   , EMAIL_NOT_VERIFIED:'Η διεύθυνση ηλεκτρονικού ταχυδρομείου σας δεν έχει επαληθευτεί. Ελέγξτε τα εισερχόμενά σας.'
   , CARD_ALREADY_EXIT:'Ο αριθμός κάρτας {0} υπάρχει ήδη.'
   , JAIL_BROKEN_MESSAGE:"Η συσκευή σας έχει παραβιαστεί. Η εφαρμογή δεν μπορεί να εκτελεστεί"
   , NOT_SUPPORT_REGION: 'We are not supported in your region'
   , RESEND_EMAIL_SUCCESS: "Resend verification email successfully. Please check the link sent to your email and follow the instructions to verify your account."
   , REQUEST_WALLET_FUNDS_AMOUNT_INVALID:'Μη έγκυρο ποσό. Το ποσό δεν μπορεί να υπερβεί τα '
   , INVALID_QRCODE:"Sorry, something went wrong. Please try again."
   , RECEIPT_ALEADY_EXIST:"Sorry, a request for this receipt already exists."
   , RECLAIM_PURCHASE_SUCCESS:'It will take just a moment before awards are shown in your wallet'
   , INVALID_PASSWORD_EXCEPTION:"The password is not in a valid format"
   , PASSWORD_LENGTH_EXCEPTION:'Password must be at least 8 characters long and must not contain sequences (i.e. "123456" or "abcdef")'
   , NAMEDAY_NOT_CONFIG: 'Name Days not configured. Please contact support.'
   , TOPUP_SUCCESS: 'Το πορτοφόλι σας φορτώθηκε με επιτυχία.'
   , TOPUP_FAILED: 'Η επαναφόρτωση πορτοφολιού απέτυχε. Η κάρτα σας δεν έχει χρεωθεί.'
   , PAYMENT_SUCCESS: 'Payment successfully'
   , PAYMENT_FAILED: 'Payment failed'
   , ADDCARD_SUCCESS: 'Add card successfully'
   , ADDCARD_FAILED: 'Add card failed'
   , WALLET_FUND_INSUFFICIENT:'Ανεπαρκή χρήματα πορτοφολιού'
   , CUSTOMER_EMAIL_ALREADY_EXIST: 'Paypal account already exist'
   , TOO_MANY_REQUESTS:"Υποβλήθηκαν πάρα πολλά αιτήματα. Παρακαλώ προσπαθήστε ξανά αργότερα"
   , TOO_MANY_RECIPIENTS_EXCEPTION:"Μόνο δέκα αποδέκτες επιτρέπονται"
   , PROMO_CODE_INVALID:"ωδικός προσφοράς λανθασμένη."
   , REDEEM_A_PASS_FAIL:"Η εξαργύρωση της δωροκάρτας απέτυχε."
   , REDEEM_A_PASS_SUCCESS:"Η δωροκάρτα εξαργυρώθηκε με επιτυχία."
   , REDEEM_PASS_INVALID:"Σφάλμα κατά την εξαργύρωση της δωροκάρτας. Μη έγκυρος αριθμός δωροκάρτας ή υποχρεωτικό PIN."
   , REDEEM_PASS_USED:"Σφάλμα εξαργύρωσης της δωροκάρτας. Η δωροκάρτα έχει ήδη εξαργυρωθεί."
   , SERVICE_ALREADY_EXIST:"Προσπαθείτε να παραγγείλετε μια υπηρεσία στην οποία έχετε ήδη εγγραφεί. Ακυρώστε την παραγγελία και δοκιμάστε ξανά."

   // New only portal
   , place_an_order: 'Παραγγείλετε online τώρα!'
   , show_on_map: 'Τοποθεσίες'
   , merchant_near_you: 'Locations'
   , text_title_to_be_replace: 'Προσφορές'
   , edit_profile: 'Επεξεργασία προφίλ'
   , more_info: 'Περισσότερες πληροφορίες'
   , enter_same_password: 'Passwords do not match'
   , enter_your_otp: 'Enter your OTP'
   , otp_code: 'OTP Code'
   , verify_your_phone_number: 'Verify your phone number'
   , or_sign_in_with: 'Or sign in with'
   , enable_location_permissions: 'Can not get location because not access your location.Please allow location access to use features'
   , load_more: 'Load More'
   // all
   , receive_marketing_information: 'Receive marketing information via:'
   , refer_send_success: 'Friend referral(s) successfully sent'
   , referral_code: 'Referral Code (optional)'
   , CARD_NOT_FOUND: 'You have no card for payment yet. Please add a card'
   , INVALID_CONTACTPASSWORD_EXCEPTION: 'Ο κωδικός πρόσβασης πρέπει να είναι τουλάχιστον 8 (αλφαριθμητικοί και/ή ειδικοί) χαρακτήρες και δεν πρέπει να περιέχει ακολουθίες χαρακτήρων ή αριθμών (π.χ. “αβγδ” ή “1234”) ή να έχει χρησιμοποιηθεί ξανά.'
   , CAN_NOT_FIND_CUSTOMER: 'Can not find customer'
}
export default {
   greek
}